import './index.less';

import Interact from './Interact.vue';

Interact.install = function install(Vue) {
  Vue.component(Interact.name, Interact);
};

export default Interact;
